import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

export const ASSET_NAME = 'paddle_genius';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { paddleGeniusPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
